import React from "react";
import Biofouling1 from "components/app/report/other/biofouling1/Biofouling1";

function ScreenBiofouling1() {
	return <Biofouling1 />;
}

export default ScreenBiofouling1;
